const EntityType = {
    SUPPLIER: 1,
    DISTRIBUTER: 2,
    AGENT: 3,
    CUSTOMER: 4
}
export default EntityType
